<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-project-manager-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Add Manager
            </h4>
          </div>

          <div class="modal-body">
            <TypeaheadWidget
                v-model="data.user_id"
                name="user_id"
                label="User"
                endpoint="/api/v2/users"
                :token="shared.token"
                path="data.data"
                placeholder="Search..."
                :result-label-property="row => row.attributes.full_name"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import TypeaheadWidget from "../../../../vendor/forms/FormGroups/Widgets/Typeahead.vue";
import store from '@/store'

export default {
  components: {TypeaheadWidget},

  mixins: [Errors],

  props: {
    project: {
      required: true
    },
  },

  data() {
    return {
      data: {},

      shared: store
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/projects/' + this.project.id + '/project-managers', this.data)
          .then(response => {
            notify.success('The user was added to the sales team.')

            this.$emit('created', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
